<section class="hero is-fullheight">
  <div class="hero-body">
    <div class="container has-text-centered">
      <div class="columns">
        <div class="column col-login">
          <div>
            <figure class="logo" style="padding:12px 20px" >
              <img src="../../../../assets/images/logo.svg" alt="logo test" />
            </figure>

            <h3 class="title is-2 my-5">Sign in</h3>
            <form [formGroup]="loginForm" (submit)="submitForm(loginForm)">
              <div class="field mb-5">
                <div class="control">
                  <input
                    class="input is-large has-background-light"
                    type="email"
                    placeholder="Email"
                    formControlName="email"
                    autofocus=""
                  />
                </div>
              </div>
              <div class="field mb-5">
                <div class="control">
                  <input
                    class="input is-large has-background-light"
                    type="password"
                    placeholder="Password"
                    formControlName="password"
                    (keydown.enter)="textareaEnterPressed($event)"
                  />
                </div>
              </div>
              <button
                class="button is-link is-large is-fullwidth mb-3"
                [disabled]="loginForm.invalid"
              >
                <span class="has-text-weight-bold">Sign in</span>
              </button>
            </form>
          </div>
        </div>
        <div class="column col-decoration">
          <div class="drawing">
            <img src="../../../../assets/images/bg-3.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
